module.exports = __webpack_public_path__ + "static/media/wind.b4ae2a98.svg";